<template>
  <div class="login">
    <div class="bgMp4">
      <video src="https://assets.codehub.cn/images/complete.0353b892.mp4" autoplay muted loop></video>
    </div>
    <div class="loginWindow">
      <div class="apply" v-if="$COMPANY_NAME != 'tj'"></div>
      <div class="apply" v-else @click="isShowApplyDialog = true">
        <i class="el-icon-shenqing"></i>
        <span class="text">入职申请</span>
      </div>
      <div class="loginTile">
        <div class="logo"><img :src="env.LOGIN_FORM_LOGO" alt="" /></div>
        <div class="name">{{ env.LOGIN_FORM_TITLE }}</div>
      </div>
      <div class="loginForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="User Name" prop="userName">
            <el-input class="loginName" type="text" v-model="ruleForm.userName" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <i class="el-icon-loginyonghu"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="Password" prop="passWord">
            <el-input class="loginPassWord" :type="flag ? 'text' : 'password'" v-model="ruleForm.passWord" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <i class="el-icon-mima"></i>
              </template>
              <template slot="suffix">
                <i :class="flag ? 'el-icon-loginzhengyan' : 'el-icon-loginbiyan'" @click="flag = !flag"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="VerificationCode" prop="smsCode" v-if="$ENV.ISSMSCODESHOW">
            <el-input class="smsCode" type="text" v-model="ruleForm.smsCode">
              <template slot="prefix">
                <i class="el-icon-message"></i>
              </template>
              <template slot="suffix">
                <el-button type="text" @click="sendSmsCode" :disabled="smsButtonDisabled">
                  {{ smsButtonText }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="loginSubmit" type="primary" round @click="loginEvent" :loading="loginLoad"> 登 录 </el-button>
        <div class="version">{{ $ENV.COPYRIGHT }} 版本：{{ $ENV.VERSION }}</div>
      </div>
    </div>
    <ApplyDialog :isShow.sync="isShowApplyDialog" />
  </div>
</template>
<script>
import ApplyDialog from './applyDialog.vue';
import mixin from './mixin';
export default {
  name: 'login',
  components: { ApplyDialog },
  mixins: [mixin],
  data() {
    return {
      isShowApplyDialog: false,
    };
  },
};
</script>
<style scoped lang="less">
@keyframes windowAnimation {
  from {
    top: 60%;
    opacity: 0;
  }
  to {
    top: 50%;
    opacity: 1;
  }
}
.login {
  position: relative;
  .bgMp4 {
    height: 100vh;
    display: flex;
    justify-content: center;
    // background: #222536;
    transform: rotate(0deg) scale(1) rotateY(180deg);
    overflow: hidden;
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .loginWindow {
    width: 454px;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(37, 38, 44, 0.08);
    border-radius: 20px;
    position: absolute;
    top: 50%;
    right: 160px;
    transform: translateY(-55%);
    padding: 0 40px;
    animation: windowAnimation 1s;
    .apply {
      display: flex;
      justify-content: end;
      align-items: center;
      padding-top: 32px;
      font-size: 16px;
      color: #154f9d;
      cursor: pointer;
      .text {
        padding-left: 4px;
      }
    }
    .loginTile {
      .logo {
        margin-top: 14px;
        width: 105px;
        height: 41px;
        img {
          height: 100%;
        }
      }
      .name {
        font-size: 20px;
        font-weight: 400;
        color: #1a306c;
        margin-top: 16px;
      }
    }
    .loginForm {
      margin-top: 32px;
      .el-form-item {
        margin-bottom: 20px;
      }
      .loginName,
      .loginPassWord,
      .smsCode {
        /deep/ .el-input__inner {
          background: #f7f9fc;
          border-radius: 20px;
          padding: 0 48px;
        }
      }
      .loginSubmit {
        width: 374px;
        background: #154f9d;
        margin-top: 12px;
      }
      .version {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        margin-top: 12px;
        text-align: center;
        padding-bottom: 16px;
      }
      .el-icon-loginyonghu,
      .el-icon-mima,
      .el-icon-message {
        font-size: 20px;
        margin-left: 8px;
        margin-top: 10px;
      }
      .el-icon-loginzhengyan,
      .el-icon-loginbiyan {
        font-size: 20px;
        color: #154f9d;
        margin-top: 10px;
        margin-right: 8px;
      }
    }
  }
}
</style>
